import { Button, Col, Modal, Row } from 'antd';
import { MouseEventHandler } from 'react';
import { XSquare } from 'react-bootstrap-icons';
import { createPortal } from 'react-dom';
import DefaultButton from '../buttons/DefaultButton';
import PrimaryButton from '../buttons/PrimaryButton';

type FooterConfirmAction = {
  label: string;
  onClick: () => void;
  // onClick: MouseEventHandler;
  isLoading?: boolean;
  isDisabled?: boolean;
};

type FooterCancelAction = {
  label: string;
  onClick: () => void;
  // onClick: MouseEventHandler;
};

type ConfirmModelComponentProps = {
  styleClasses?: string;
  isOpen: boolean;
  onClickedCancel: any;
  header?: any;
  content: any;
  footer?: any;
  closeIcon?: any;
  headerContent?: any;
  footerAction?: {
    confimation?: FooterConfirmAction;
    cancel?: FooterCancelAction;
  };
  modelType?: ModelType;
};

export enum ModelType {
  DANGER = 'DANGER',
  SUCCESS = 'SUCCESS',
}

const ConfirmModelComponent = (props: ConfirmModelComponentProps) => {
  const {
    styleClasses = '!w-1/4 min-w-[330px] md:min-w-[380px]',
    isOpen,
    onClickedCancel,
    header,
    content,
    footer,
    closeIcon,
    headerContent,
    footerAction,
    modelType,
  } = props;

  const footerCancelAction = (cancelAction: FooterCancelAction) => (
    // <Button onClick={cancelAction.onClick} className="btn-default w-full">
    //   {cancelAction.label}
    // </Button>
    <DefaultButton handleOnClick={cancelAction.onClick} width="100%">
      {cancelAction.label}
    </DefaultButton>
  );

  const footerConfirmAction = (confirmAction: FooterConfirmAction) => (
    // <Button
    //   onClick={confirmAction.onClick}
    //   loading={confirmAction.isLoading}
    //   htmlType="submit"
    //   disabled={confirmAction.isDisabled}
    //   // className={`${modelType === ModelType.SUCCESS ? 'btn-primary' : 'btn-primary-danger'} w-full`}
    //   className={'btn-primary w-full'}
    // >

    // </Button>
    <PrimaryButton
      handleOnClick={confirmAction.onClick}
      width="100%"
      hideBgGradient={true}
      disabled={confirmAction?.isDisabled || false}
    >
      {confirmAction.label}
    </PrimaryButton>
  );

  const modalContent = (
    <Modal
      className={styleClasses}
      centered
      open={isOpen}
      footer={null}
      closeIcon={closeIcon ? closeIcon : <XSquare className="text-primary-gray-500" size={20} />}
      maskClosable={false}
      onCancel={onClickedCancel}
      style={{ zIndex: 99999, maxWidth: '90%' }}
    >
      <div>
        {headerContent ? (
          <Row justify="center">{headerContent}</Row>
        ) : (
          <Row justify="center">
            <label className="text-primary-font-gray mb-6 text-center text-lg font-bold md:text-xl">
              {header}
            </label>
          </Row>
        )}
        {content.length !== 0 && (
          <div className="text-md mb-8 px-2 text-center md:text-lg">{content}</div>
        )}
        <div className="px-1 md:px-6">
          {footerAction && footerAction.confimation && footerAction.cancel ? (
            <Row justify="center" className="my-2">
              <Col span={12} className="pr-4">
                {footerCancelAction(footerAction.cancel)}
              </Col>
              <Col span={12} className="pl-4">
                {footerConfirmAction(footerAction.confimation)}
              </Col>
            </Row>
          ) : footerAction && footerAction.confimation && !footerAction.cancel ? (
            <Row justify="center" className="my-2">
              <Col span={24} className="pl-4">
                {footerConfirmAction(footerAction.confimation)}
              </Col>
            </Row>
          ) : (
            footer
          )}
        </div>
      </div>
    </Modal>
  );

  return isOpen ? createPortal(modalContent, document.body) : null;
};

export default ConfirmModelComponent;
